import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faTimes } from "@fortawesome/free-solid-svg-icons";

import { DEFAULT_MAGNETBOARD_EXCEL_EXPORT_OPTIONS } from "../utils/magnetboardExcelExport";

const EMPTY_ROW_LABELS = {
  teacher:"teachers",
  course:"courses",
  classroom:"classrooms",
  student:"students",
};

export default function MagnetboardExcelExportOptionsModal({
  currentView,
  rowCount,
  onClose,
  onExport,
}) {
  const [draftExportOptions, setDraftExportOptions] = useState({
    ...DEFAULT_MAGNETBOARD_EXCEL_EXPORT_OPTIONS,
  });

  const updateDraftExportOption = (optionKey, value) => {
    setDraftExportOptions(currentOptions => ({
      ...currentOptions,
      [optionKey]:value,
    }));
  };
  const emptyRowLabel = EMPTY_ROW_LABELS[currentView] || "rows";

  return (
    <div className="mb-print-options-modal-screen mb-excel-export-options-modal-screen">
      <div className="mb-print-options-modal-content">
        <div className="mb-print-options-modal-header">
          <div>
            <h2>Export to Excel</h2>
            <div className="mb-print-options-modal-subtitle">
              Configure the workbook for the {rowCount} currently visible {rowCount === 1 ? "row" : "rows"}.
            </div>
          </div>
          <button type="button" className="mb-print-options-icon-btn" onClick={onClose} aria-label="Close Excel export options">
            <FontAwesomeIcon icon={faTimes}/>
          </button>
        </div>

        <div className="mb-print-options-layout mb-print-options-layout-no-filters">
          <div className="mb-print-options-panel">
            <div className="mb-print-options-panel-title">Workbook options</div>
            <div className="mb-print-options-toggle-list">
              <label className="mb-print-options-toggle-row">
                <input
                  type="checkbox"
                  checked={draftExportOptions.separateDepartments}
                  onChange={event => updateDraftExportOption("separateDepartments", event.target.checked)}
                />
                <span>Separate departments into their own tabs</span>
              </label>
              <label className="mb-print-options-toggle-row">
                <input
                  type="checkbox"
                  checked={draftExportOptions.includeEmptyRows}
                  onChange={event => updateDraftExportOption("includeEmptyRows", event.target.checked)}
                />
                <span>Include empty {emptyRowLabel}</span>
              </label>
              <label className="mb-print-options-toggle-row">
                <input
                  type="checkbox"
                  checked={draftExportOptions.includeClassrooms}
                  onChange={event => updateDraftExportOption("includeClassrooms", event.target.checked)}
                />
                <span>Include classrooms</span>
              </label>
              <label className="mb-print-options-toggle-row">
                <input
                  type="checkbox"
                  checked={draftExportOptions.includeStudentSeatCounts}
                  onChange={event => updateDraftExportOption("includeStudentSeatCounts", event.target.checked)}
                />
                <span>Include student seat counts</span>
              </label>
            </div>
          </div>
        </div>

        <div className="mb-print-options-modal-footer">
          <button type="button" className="mb-print-options-secondary-btn" onClick={onClose}>Cancel</button>
          <button
            type="button"
            className="mb-print-options-primary-btn"
            onClick={() => onExport({exportOptions:draftExportOptions})}
          >
            <FontAwesomeIcon icon={faFileExcel}/>
            Export
          </button>
        </div>
      </div>
    </div>
  );
}
